import React, { useEffect, useMemo, useState } from 'react';
import ReactDOM from 'react-dom';
import getIdentifier from 'getIdentifier';
export const REACT_PORTAL_CHILDREN = 'react-portal-children';

const ReactPortal = ({
  children,
  elementId,
  isTestModeDisabled,
}: {
  children: React.ReactNode;
  elementId: string;
  isTestModeDisabled?: boolean;
}) => {
  const [, setKey] = useState<string>(getIdentifier());
  const [retries, setRetries] = useState<number>(0);
  const retryLimit = 3;

  const PortalContent = useMemo(() => {
    return <div id={REACT_PORTAL_CHILDREN}>{children}</div>;
  }, [children]);

  useEffect(() => {
    const domNode = document.getElementById(elementId);
    if (!domNode) {
      const to = setTimeout(
        () => {
          if (retries < retryLimit) {
            setRetries(retries + 1);
            setKey(getIdentifier());
          }
        },
        200 * 2 ** retries,
      );

      return () => {
        clearTimeout(to);
      };
    } else {
      setRetries(0);
    }
  }, [elementId, retries]);

  if (process.env.NODE_ENV === 'test' && !isTestModeDisabled) {
    return <>{PortalContent}</>;
  }

  const domNode = document.getElementById(elementId);
  if (domNode) {
    return ReactDOM.createPortal(PortalContent, domNode);
  }

  return null;
};

export default ReactPortal;
